import { ROUTES } from '@/constants/routes';
import type { NotificationListItem } from '@/types/notification';

export function resolveNotificationTarget(
  variant: 'leader' | 'employee',
  item: Pick<
    NotificationListItem,
    'type' | 'businessType' | 'payload' | 'project' | 'task' | 'report' | 'projectReport'
  >,
): string | null {
  const payload = item.payload ?? {};
  const projectId = payload.projectId ?? item.project?.id;
  const taskId = payload.taskId ?? item.task?.id;
  const reportId = item.report?.id;
  const projectReportId = payload.projectReportId ?? item.projectReport?.id;

  if (item.businessType === 'PROJECT_REPORT' && projectReportId && projectId) {
    if (variant === 'leader') {
      return ROUTES.mobile.leader.projectReportDetail(projectId, projectReportId);
    }
    return ROUTES.mobile.employee.projectReportDetail(projectId, projectReportId);
  }

  switch (item.type) {
    case 'PROJECT':
      if (variant === 'leader' && projectId) {
        return ROUTES.mobile.leader.projectDetail(projectId);
      }
      if (variant === 'employee' && projectId) {
        return ROUTES.mobile.employee.projectDetail(projectId);
      }
      return null;
    case 'TASK':
      if (variant === 'employee' && taskId) {
        return ROUTES.mobile.employee.taskDetail(taskId);
      }
      if (variant === 'leader' && projectId && taskId) {
        return ROUTES.mobile.leader.projectTaskDetail(projectId, taskId);
      }
      return null;
    case 'COMMENT':
      if (projectReportId && projectId) {
        if (variant === 'leader') {
          return ROUTES.mobile.leader.projectReportDetail(projectId, projectReportId);
        }
        return ROUTES.mobile.employee.projectReportDetail(projectId, projectReportId);
      }
      if (variant === 'leader' && reportId) {
        return ROUTES.mobile.leader.teamReportDetail(reportId);
      }
      if (variant === 'employee' && reportId) {
        return `${ROUTES.mobile.employee.reports}?tab=history&reportId=${reportId}`;
      }
      return null;
    default:
      return null;
  }
}

export function notificationActionLabel(item: Pick<NotificationListItem, 'type' | 'businessType'>): string {
  if (item.businessType === 'PROJECT_REPORT') {
    return '查看项目日报';
  }
  switch (item.type) {
    case 'PROJECT':
      return '查看项目';
    case 'TASK':
      return '查看任务';
    case 'COMMENT':
      return '查看日报';
    default:
      return '查看详情';
  }
}
